import { combineReducers } from '@reduxjs/toolkit';

const combinedReducers = combineReducers({
    login: require("./login/loginSlice").default,
    accountSummary: require("./myAccount/accountSummarySlice").default,
    buyFlowMap: require("./buyOnline/mapSlice").default,
    getCustomerDetails: require("./myAccount/getCustomerDetails").default,
    globalContent: require("./globalContent/globalContentSlice").default,
    appointmentSchedule: require("./appointmentScheduleSlice").default
});

const rootReducer = (state, action) => {
  if (action.type === 'RESET_REDUX_STATE') {
    // setting the state to undefined will cause all reducers to return their initial state
    state = undefined; 
  }
  return combinedReducers(state, action);
};

export default rootReducer;